import { render, staticRenderFns } from "./VMainColumnRecordVisualization.vue?vue&type=template&id=541dc976"
import script from "./VMainColumnRecordVisualization.vue?vue&type=script&lang=js"
export * from "./VMainColumnRecordVisualization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('541dc976')) {
      api.createRecord('541dc976', component.options)
    } else {
      api.reload('541dc976', component.options)
    }
    module.hot.accept("./VMainColumnRecordVisualization.vue?vue&type=template&id=541dc976", function () {
      api.rerender('541dc976', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commons/VMainColumnRecordVisualization.vue"
export default component.exports